import React, { useMemo } from "react";

import { Color } from "../helpers";

type Props = Readonly<{
  color: Color;
}>;

export const ColorSwatch = ({ color }: Props) => {
  const styles = useMemo(() => {
    const transparent = color.copy();
    if (transparent.alpha > 0.5) {
      transparent.alpha = 0.5;
    }
    return {
      backgroundColor: transparent.toRGBAString(),
    };
  }, [color]);
  return <div className="color-swatch" style={styles} />;
};
ColorSwatch.displayName = "ColorSwatch";
